import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "../../../../components/AppModal/AppModal";
import WebService, { BASE_URL } from "../../../../utility/WebService";
import SucessModal from "../../../../components/SucessModal/Sucess";
import WarningModal from "../../../../components/Warning/Warning";
import AlertModal from "../../../../components/AlertComponent/Alert";
import SpringMoneyPagination from "../../../../components/SpringMoney/Pagination/SpringMoneyPagination";
import HelperService from "../../../../utility/HelperService";
import "../../Masters/MasterList.css";

/* ---- inline stroke icons (apv style, kept local to this screen) ---- */
const IconSearch = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></svg>
);
const IconEdit = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z" /></svg>
);
const IconDownload = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12" /><path d="M7 10l5 5 5-5" /><path d="M5 21h14" /></svg>
);
const IconArrowRight = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 5l7 7-7 7" /></svg>
);
const IconStar = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 18.8 6.2 21.9l1.1-6.5L2.6 10.7l6.5-.9L12 3z" /></svg>
);

const agreementTypeLabel = (t: any) =>
    t === "AADHAR_E_SIGN" ? "Aadhar E-Sign" :
        t === "E_SIGN" ? "Wet Sign" :
            t === "SCANED_BY_BOTH" ? "Physical" : "-";

const CompletedAgreement = () => {
    const [showLoader, setShowLoader] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1)
    const [searchText, setSearchText] = useState('');
    const [agreement, setAgreement] = useState<any[]>([]);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");
    const [isShoWDeleteModal, setShowDeleteModal] = useState(false);
    const [clientId, setClientId] = useState<any>();
    const [clientName, setClientName] = useState('');
    const pageSizeKey = "ml_pagesize_agreement_completed_page_size_" + (user_data?.user_id || "default");
    const PAGE_SIZES = [10, 25, 100, 250, 500];
    const readSavedPageSize = () => {
        const v = parseInt(localStorage.getItem(pageSizeKey) || "", 10);
        return PAGE_SIZES.indexOf(v) >= 0 ? v : 100;
    };
    const [itemsCountPerPage, setItemsCountPerPage] = useState<number>(() => readSavedPageSize());
    const [defaultPageSize, setDefaultPageSize] = useState<number>(() => readSavedPageSize());
    const [TotalPages, setTotalPages] = useState<number>();
    const [goToPageNumber, setGoToPageNumber] = useState<string>("");
    let history = useNavigate();

    useEffect(() => {
        getList(1);
    }, []);

    // load the user's saved default page size from their account so it follows
    // them across devices (localStorage above is just an instant local cache)
    useEffect(() => {
        WebService.getAPI({ action: `/v2/UserSetting/Get?key=agreement_completed_page_size`, body: null })
            .then((res: any) => {
                const v = parseInt(res?.value, 10);
                if (PAGE_SIZES.indexOf(v) >= 0) {
                    setDefaultPageSize(v);
                    setItemsCountPerPage(v);
                    try { localStorage.setItem(pageSizeKey, String(v)); } catch (e) { }
                }
            })
            .catch(() => { });
    }, []);

    useEffect(() => {
        getList(currentPage);
    }, [currentPage, itemsCountPerPage]);

    const getList = (page: Number) => {
        setShowLoader(true)
        WebService.getAPI({
            action: `${user_data.is_person == 'Employee' ? `/v2/ClientAgreements/GetAgreementList` : `/v2/ClientAgreements/GetClientAgreementList`}?page=${page}&status=COMPLETED&keyword=${encodeURIComponent(searchText)}&limit=${itemsCountPerPage}`,
            body: null
        })
            .then((res: any) => {
                setShowLoader(false)
                setAgreement(res.list)
                setTotalCount(res.total_count)
            })
            .catch((e) => {
                setShowLoader(false)
            })
    };

    const download = (id: any) => {
        setShowLoader(true);
        window.open(`${BASE_URL}/v2/ClientAgreements/DownloadFinalDocument?id=${id}`)
        setShowLoader(false)
    }

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setShowLoader(false);
    }
    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setShowLoader(false);
    }
    const closeModal = () => {
        setShowDeleteModal(false);
        setShowLoader(false);
    };
    const goToRenewalPage = () => {
        history(`/admin/mis-report/renew-agreement/${clientId}`, {
            state: {
                name: clientName
            }
        });
    }

    const handlePagination = (itemCount: number) => {
        setItemsCountPerPage(itemCount);
        setCurrentPage(1);
    };

    const saveDefaultPageSize = () => {
        try { localStorage.setItem(pageSizeKey, String(itemsCountPerPage)); } catch (e) { }
        setDefaultPageSize(itemsCountPerPage);
        WebService.postAPI({
            action: `/v2/UserSetting/Save`,
            body: { key: "agreement_completed_page_size", value: String(itemsCountPerPage) }
        }).catch(() => { });
        toast.success(`Showing ${itemsCountPerPage} per page by default from now on.`);
    };

    const handleGoToPageInput = (e: any) => {
        if (e.key === "Enter" && goToPageNumber !== "") {
            if (TotalPages && Number(goToPageNumber) > TotalPages) {
                setCurrentPage(TotalPages);
            } else {
                setCurrentPage(Number(goToPageNumber));
            }
        }
    };

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <AlertModal
                show={isShoWDeleteModal}
                isClose={closeModal}
                delete={goToRenewalPage}
                data={clientId}
                message={'Are you sure want to renew Agreement?'}
                button1={'Yes'}
                button2={'No'}
            />
            <div className="ml-card">
                <div className="ml-toolbar">
                    <div className="ml-sizes">
                        <span>Show:</span>
                        {PAGE_SIZES.map((size) => (
                            <button
                                key={size}
                                type="button"
                                onClick={() => handlePagination(size)}
                                className={`ml-size-btn ${itemsCountPerPage === size ? "active" : ""}`}
                            >
                                {size}
                            </button>
                        ))}
                        <span className="ml-sizes-sep"></span>
                        <button
                            type="button"
                            className="ml-setdefault"
                            onClick={saveDefaultPageSize}
                            disabled={itemsCountPerPage === defaultPageSize}
                            title="Remember this page size for your next login"
                        >
                            <IconStar /> Set as default
                        </button>
                        <span className="ml-defnote">Default: {defaultPageSize}</span>
                    </div>
                    <div className="ml-tools">
                        <div className="ml-search">
                            <IconSearch />
                            <input
                                id="search"
                                name="search"
                                placeholder="Search"
                                type="search"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                onKeyUp={(e) => {
                                    if (e.keyCode === 13) {
                                        getList(1)
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="ml-tablewrap">
                    <table className="ml-table">
                        <thead>
                            <tr>
                                <th>Client Name</th>
                                <th>Agreement Type</th>
                                <th>Client Ip</th>
                                <th>Client Signed Date</th>
                                <th>Advisor Signed Date</th>
                                <th>Agreement Start Date</th>
                                <th>Agreement End Date</th>
                                <th>Date</th>
                                <th className='text-center' style={{ width: "150px" }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {showLoader && Array.from({ length: 8 }).map((_, i) => (
                                <tr key={'sk-' + i} className="ml-skrow">
                                    <td><span className="ml-sk" style={{ width: "60%" }}></span></td>
                                    <td><span className="ml-sk" style={{ width: "50%" }}></span></td>
                                    <td><span className="ml-sk" style={{ width: "50%" }}></span></td>
                                    <td><span className="ml-sk" style={{ width: "55%" }}></span></td>
                                    <td><span className="ml-sk" style={{ width: "55%" }}></span></td>
                                    <td><span className="ml-sk" style={{ width: "55%" }}></span></td>
                                    <td><span className="ml-sk" style={{ width: "55%" }}></span></td>
                                    <td><span className="ml-sk" style={{ width: "55%" }}></span></td>
                                    <td className="text-center"><span className="ml-sk ml-sk-pill" style={{ width: "80px", margin: "0 auto" }}></span></td>
                                </tr>
                            ))}
                            {!showLoader && agreement.length > 0 && agreement.map((res, index) => {
                                return (
                                    <tr key={index}>
                                        <td className="ml-name">{res.client_name ? res.client_name : "-"}</td>
                                        <td>{agreementTypeLabel(res.agreement_type)}</td>
                                        <td>{res.ip_client ? res.ip_client : "-"}</td>
                                        <td>{res.client_signed_date ? HelperService.getFormatedDateAndTime(res.client_signed_date) : "-"}</td>
                                        <td>{res.advisor_signed_date ? HelperService.getFormatedDateAndTime(res.advisor_signed_date) : "-"}</td>
                                        <td>{res.start_date ? HelperService.getFormatedDateByDMY(res.start_date) : "-"}</td>
                                        <td>{res.end_date ? HelperService.getFormatedDateByDMY(res.end_date) : "Perpetual"}</td>
                                        <td>{res.created_at ? HelperService.getFormatedDateByDMY(res.created_at) : "-"}</td>
                                        <td className='text-center'>
                                            <div className="ml-actions">
                                                <button type="button" className="ml-act blue" title="Download" onClick={() => download(res.id)}>
                                                    <IconDownload />
                                                </button>
                                                {user_data.is_person == 'Employee' &&
                                                    <>
                                                        <button type="button" className="ml-btn ml-btn-brand" title="Renew"
                                                            onClick={() => {
                                                                setShowDeleteModal(true)
                                                                setClientId(res.client_id)
                                                                setClientName(res.client_name);
                                                            }}
                                                            disabled={res.is_disabled}
                                                        >
                                                            Renew</button>
                                                        <button type="button" className="ml-act blue" title="Edit" onClick={() => history(`/admin/mis-report/edit-agreement/${res.client_id}/${res.id}`, {
                                                            state: {
                                                                name: res.client_name
                                                            }
                                                        })}>
                                                            <IconEdit />
                                                        </button>
                                                    </>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>

                {agreement.length == 0 && showLoader == false &&
                    <div className="ml-empty">
                        <div className="ml-empty-ic">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="11" cy="11" r="7" />
                                <path d="M21 21l-4.3-4.3" />
                            </svg>
                        </div>
                        <h2>No Records Found</h2>
                        <p>Try a different search term.</p>
                    </div>
                }

                {totalCount > 0 &&
                    <div className="ml-pager">
                        <div className="ml-total">Total count: <b>{totalCount}</b></div>
                        <div>
                            <SpringMoneyPagination
                                currentPageNo={currentPage}
                                setCurrentPageNo={setCurrentPage}
                                itemsCountPerPage={itemsCountPerPage}
                                totalItems={totalCount}
                                TotalPages={TotalPages}
                                setTotalPages={setTotalPages}
                            />
                        </div>
                        <div className="ml-goto">
                            <span>Go to page</span>
                            <input
                                onKeyDown={handleGoToPageInput}
                                type="number"
                                value={goToPageNumber}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^[1-9]\d*$/.test(value) || value === "") {
                                        setGoToPageNumber(value);
                                    }
                                }}
                            />
                            <a title="Next" onClick={() => {
                                if (goToPageNumber !== "") {
                                    if (TotalPages && (Number(goToPageNumber) > TotalPages)) {
                                        setCurrentPage(TotalPages);
                                    } else {
                                        setCurrentPage(Number(goToPageNumber));
                                    }
                                }
                            }}>
                                <IconArrowRight />
                            </a>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}
export default CompletedAgreement;
